import React, { FC } from 'react';
import { NewsRelatedPostsSection, NewsSocialMediaSection, NewsContentSection, NewsImageSection } from 'containers/news';
import { NewsPostList, NewsSinglePost } from 'services/news/types';

interface NewsContentArrayProps {
  data: NewsSinglePost;
  relatedPosts: Array<NewsPostList>;
}

const NewsPageWrapper: FC<NewsContentArrayProps> = ({ data, relatedPosts }) => {
  return (
    <>
      <NewsImageSection image={data.image} />
      <NewsContentSection post={data} />
      <NewsSocialMediaSection post={data} />
      <NewsRelatedPostsSection listCards={relatedPosts} />
    </>
  );
};

export default NewsPageWrapper;
